<script>
export default {
  name: 'modal-handler',
  props: {
    componentName: {
      type: String,
      default: 'empty-component',
    },
    objectItem: {
      required: false,
    },
    modalClass: {
      type: String,
      default: 'modal--size_sm',
    },
    afterModalRequest: {
      type: Function,
    },
    clickToClose: {
      type: Boolean,
      default: true,
    },
  },
  render() {
    return this.$scopedSlots.default({
      handler: this.toggleModalHandler,
    })
  },
  methods: {
    toggleModalHandler() {
      if (!this.componentName) return
      this.$modal.show(() => import('./CommonModal'), {
        component: this.componentName,
        objectItem: this.objectItem,
        afterModalRequest: this.afterModalRequest,
      }, {
        classes: `modal modal--container ${this.modalClass}`,
        name: 'modal',
        clickToClose: this.clickToClose,
      })
    },
  },
}
</script>
